/* eslint-disable camelcase */

import type {
  SupraLockboxActivities,
  MasterLockOpenLockboxEvent,
  MasterLockOpenShackleEvent,
} from '@bb/domain/dist/types';
import type { User } from '@bb/users';
import type { ListingDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';
import type { ColorNameType, IconNameType } from '../../../components';

export type lockboxesActivityPageTabs = 'Lockboxes' | 'User';

export const keyTypes = ['primary', 'inspector', 'agent', 'N/A'];

export const lockboxActivityIcons: Record<
  | SupraLockboxActivities
  | MasterLockOpenLockboxEvent
  | MasterLockOpenShackleEvent,
  { icon: IconNameType; color: ColorNameType }
> = {
  returned: { icon: 'tool', color: 'red6' },
  assigned_to_listing: { icon: 'antdHomeFilled', color: 'blue6' },
  unassigned_from_listing: { icon: 'antdHomeFilled', color: 'gray8' },
  '00': { icon: 'tool', color: 'green6' },
  '01': { icon: 'antdUnlockFilled', color: 'blue6' },
  '1A': { icon: 'calendar', color: 'gray8' },
  '1B': { icon: 'calendar', color: 'gray8' },
  '1C': { icon: 'calendar', color: 'gray8' },
  '1D': { icon: 'calendar', color: 'gray8' },
  assignee_changed: { icon: 'antdHomeFilled', color: 'blue6' },
  owner_changed: { icon: 'antdHomeFilled', color: 'blue6' },
  status_changed: { icon: 'tool', color: 'blue6' },
  LockOpened: { icon: 'tool', color: 'green6' },
  UnlockWireless: { icon: 'tool', color: 'green6' },
  KeypadUnlocked: { icon: 'tool', color: 'green6' },
  ThumbturnUnlocked: { icon: 'tool', color: 'green6' },
  UnlockPrimaryCode: { icon: 'tool', color: 'green6' },
  UnlockTemporaryCode: { icon: 'tool', color: 'green6' },
  UnlockSecondaryCode1: { icon: 'tool', color: 'green6' },
  UnlockSecondaryCode2: { icon: 'tool', color: 'green6' },
  UnlockSecondaryCode3: { icon: 'tool', color: 'green6' },
  UnlockSecondaryCode4: { icon: 'tool', color: 'green6' },
  UnlockSecondaryCode5: { icon: 'tool', color: 'green6' },
  ShackleUnlockedBluetooth: { icon: 'antdUnlockFilled', color: 'blue6' },
  ShackleUnlockedPrimaryCode: { icon: 'antdUnlockFilled', color: 'blue6' },
  ShackleRemoved: { icon: 'antdUnlockFilled', color: 'blue6' },
};

export type SupraLockboxActivity = {
  key: string;
  activity: SupraLockboxActivities;
  type: string;
  lockbox: string;
  serialNo: string;
  listing: JsonObject<Partial<ListingDoc>>;
  user: JsonObject<Partial<User>>;
  keyType: typeof keyTypes;
  date: Date;
};
